<template>
  <div class="home">
    <main-slider-component></main-slider-component>

    <block-container-component>
      <template slot="content">
        <services-component></services-component>
      </template>
    </block-container-component>

    <block-container-component>
      <template slot="title">
        <block-title-component>
          <template slot="ttl">О компании</template>
          <template slot="subttl"></template>
        </block-title-component>
      </template>
      <template slot="content">
        <about-component></about-component>
      </template>
    </block-container-component>

    <block-container-component
      :hide="advhide"
      bgC="#F3F3F3"
      :bgImg="require('@/assets/img/advantages_bg.png')"
      pr0
    >
      <template slot="title">
        <block-title-component>
          <template slot="ttl">Преимущества</template>
          <template slot="subttl"></template>
        </block-title-component>
      </template>
      <template slot="content">
        <advantages-component type-of-content="advantages" @hideup="advhide=true"></advantages-component>
      </template>
    </block-container-component>

    <block-container-component
      bgC="#F3F3F3"
      :bgImg="require('@/assets/img/news_bg.png')"
      pr0
      :hide="feedbackhide"
    >
      <template slot="title">
        <block-title-component ttlcolor="#FFFFFF">
          <template slot="ttl">Новости</template>
          <template slot="subttl"></template>
        </block-title-component>
      </template>
      <template slot="content">
        <news-component type-of-content="news" @hideup="feedbackhide=true"></news-component>
      </template>
    </block-container-component>

    <block-container-component :hide="partnhide">
      <template slot="title">
        <block-title-component>
          <template slot="ttl">Нам доверяют</template>
          <template slot="subttl"></template>
        </block-title-component>
      </template>
      <template slot="content">
        <partners-component @hideup="partnhide=true"></partners-component>
      </template>
    </block-container-component>

    <!-- <cta-component>
      <template slot="button">
        <button-component class="normal-btn">Заказать звонок</button-component>
      </template>
    </cta-component>-->
  </div>
</template>


<script>
// @ is an alias to /src

export default {
  data() {
    return {
      advhide: false,
      feedbackhide: false,
      partnhide: false
    };
  }
};
</script>

<style lang="scss" scoped>
.home {
  background-color: #ffffff;
}
</style>
